// extracted by mini-css-extract-plugin
module.exports = {"container":"_80d258fc"};